import { DataRoomFolderBrowseFragmentFragment } from "@/src/graphql/generated";
import { useContext } from "react";
import { DataRoomContext } from "..";
import { DataRoomTableRow } from "../table/row";
import { sortByIndex } from "@/src/utils/sortByIndex";

export function Folders(props: {
  folder: DataRoomFolderBrowseFragmentFragment;
}) {
  const { filters, indexingEnabled, folderPills } = useContext(DataRoomContext);

  const folders = props.folder?.folders.filter((folder) => {
    if (filters.type && filters.type !== "Folder") {
      return false;
    }

    if (filters.createdBy && folder.createdBy.id !== filters.createdBy.id) {
      return false;
    }

    if (filters.lastUpdated && folder.updatedAt < filters.lastUpdated) {
      return false;
    }

    return true;
  });

  return (
    <>
      {folders
        .sort((a, b) => sortByIndex(a, b, indexingEnabled))
        .map((folder, index) => {
          const pills = folderPills.get(folder.id);
          return (
            <DataRoomTableRow
              key={folder.id}
              type="folder"
              folder={folder}
              index={index}
              ddql={pills?.ddql ?? undefined}
              question={pills?.question ?? undefined}
            />
          );
        })}
    </>
  );
}
